import { render, staticRenderFns } from "./Pravek.vue?vue&type=template&id=3e5d07b0&scoped=true&"
import script from "./Pravek.vue?vue&type=script&lang=js&"
export * from "./Pravek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5d07b0",
  null
  
)

export default component.exports